import { IS_APP_DESKTOP, window } from '../../../../helpers/BrowserHelpers';
export default function onDowload(event, _ref) {
  var url = _ref.url;
  event.preventDefault();
  event.stopPropagation();

  if (IS_APP_DESKTOP) {
    window.electron.ipcRenderer.send('download', {
      url: url
    });
  } else {
    window.open(url, '_blank');
  }

  return true;
}